import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=225e2360&scoped=true"
import script from "./breadcrumb.vue?vue&type=script&lang=js"
export * from "./breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./breadcrumb.vue?vue&type=style&index=0&id=225e2360&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225e2360",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/0/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('225e2360')) {
      api.createRecord('225e2360', component.options)
    } else {
      api.reload('225e2360', component.options)
    }
    module.hot.accept("./breadcrumb.vue?vue&type=template&id=225e2360&scoped=true", function () {
      api.rerender('225e2360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/interactive/breadcrumb.vue"
export default component.exports